import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/cube-sale/regsheet/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/cube-sale/regsheet/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/cube-sale/regsheet/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/cube-sale/regsheet/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/cube-sale/regsheet/submit',
    method: 'post',
    data: row
  })
}

export const getCompanyInfoByTaxName = (row) => {
  return request({
    url: '/api/cube-agent/companyDetail/getCompanyInfoByTaxName',
    method: 'post',
    data: row
  })
}

export const regSheetTj = (belongCompany, startCreateTime,endCreateTime) => {
  return request({
    url: '/api/cube-sale/regsheet/regSheetTj',
    method: 'get',
    params: {
      belongCompany,
      startCreateTime,
      endCreateTime
    }
  })
}

export const regSheetTjByBelongCompany = (startCreateTime,endCreateTime) => {
  return request({
    url: '/api/cube-sale/regsheet/regSheetTjByBelongCompany',
    method: 'get',
    params: {
      startCreateTime,
      endCreateTime
    }
  })
}

export const regSheetTjByDay = (belongCompany, startCreateTime,endCreateTime) => {
  return request({
    url: '/api/cube-sale/regsheet/regSheetTjByDay',
    method: 'get',
    params: {
      belongCompany,
      startCreateTime,
      endCreateTime
    }
  })
}
export const regSheetTjByPost = (belongCompany, startCreateTime,endCreateTime) => {
  return request({
    url: '/api/cube-sale/regsheet/regSheetTjByPost',
    method: 'get',
    params: {
      belongCompany,
      startCreateTime,
      endCreateTime
    }
  })
}

export const regSheetTjByYy = (startCreateTime,endCreateTime) => {
  return request({
    url: '/api/cube-sale/regsheet/regSheetTjByYy',
    method: 'get',
    params: {
      startCreateTime,
      endCreateTime
    }
  })
}

// 获取员工面试信息表接口
export const getAuditionDetail = (djid) => {
  return request({
    url: '/api/cube-sale/userygmsxxb/detail',
    method: 'get',
    params: {
      djid
    }
  })
}
// 面试信息导出
export let msxxdc = "/api/cube-sale/regsheet/msxxdc";

// 面试信息导出
export let msxxdcxq = "/api/cube-sale/regsheet/msxxdcxq";

export let rzxxdc = "/api/cube-sale/regsheet/rzxxdc";

export const getTrack = (djid) => {
  return request({
    url: '/api/cube-sale/userygmsgzb/detail',
    method: 'get',
    params: {
      djid
    }
  })
}

export const ygUpdate = (data) => {
  return request({
    url: '/api/cube-sale/userygmsxxb/submit',
    method: 'post',
    data: data
  })
}

export const gzUpdate = (data) => {
  return request({
    url: '/api/cube-sale/userygmsgzb/submit',
    method: 'post',
    data: data
  })
}

